import React, { useState } from "react";
import Grats from "assets/Grats";
import apple_app_store_badge from "assets/app-store-badge_apple.svg";
import google_play_store_badge from "assets/app-store-badge_google.svg";

const APP_BADGE_STYLING = {
  height: "3rem",
  padding: "0 .3rem"
};

const GreetingApprovalModal = ({ amount, dismiss }) => {
  const [accepted, setAccepted] = useState(true);
  const [error, setError] = useState(null);

  const dismissIfAccepted = () => {
    if (accepted) {
      dismiss();
    } else {
      setError("You must accept the terms");
    }
  };

  return (
    <div
      style={{ backgroundColor: "#FAFAFA" }}
      className="py-8 px-8 text-center"
    >
      <div className="font-black text-3xl">Congratulations!</div>
      <Grats className="m-auto py-3" />
      <div className="text-2xl font-black py-3">
        <span>You’re approved for</span>{" "}
        <span style={{ fontFamily: "HelveticaNeue-Bold", color: "#28EBC1" }}>
          ${amount}!
        </span>
      </div>
      <div>
        Please check your email for
        <br /> card shipping details.
      </div>
      <div className="pt-5">
        Download the Tomo app to get started:
        <div className="flex flex-row justify-center pt-2">
          <a
            href="https://apps.apple.com/app/apple-store/id1511011956?pt=120486263&ct=dashboard-approval-modal&mt=8"
            target="blank"
          >
            <img
              style={APP_BADGE_STYLING}
              src={apple_app_store_badge}
              alt="Download on the App Store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.tomocredit.android&hl=en_US&gl=US&pli=1&utm_source=dashboard-approval-modal&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="blank"
          >
            <img
              style={APP_BADGE_STYLING}
              alt="Get it on Google Play"
              src={google_play_store_badge}
            />
          </a>
        </div>
      </div>

      <div
        className={`inline-block rounded-sm px-6 mt-8 py-3 text-white font-semibold ${
          accepted ? "bg-green-primary cursor-pointer" : "bg-gray-400"
        } shadow`}
        onClick={dismissIfAccepted}
        disabled={!accepted}
      >
        Continue to Dashboard
      </div>
    </div>
  );
};

export default GreetingApprovalModal;
